import Box from '@mui/material/Box'
import type { ISensemakerListCard } from '@brushfire/types'
import { SENSEMAKER_LIST_CARD_GRID_GAP_PX } from '../lib/sensemaker-list-layout'
import { SensemakerCard } from './SensemakerCard'

interface Props {
  cards: ISensemakerListCard[]
  onDeactivate: (card: ISensemakerListCard) => void
  onReactivate: (card: ISensemakerListCard) => void
}

export function SensemakerCardGrid({ cards, onDeactivate, onReactivate }: Props) {
  return (
    <Box
      data-testid="sensemaker-card-grid"
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' },
        gap: `${SENSEMAKER_LIST_CARD_GRID_GAP_PX}px`,
      }}
    >
      {cards.map((card) => (
        <SensemakerCard
          key={card.tenantId}
          card={card}
          onDeactivate={onDeactivate}
          onReactivate={onReactivate}
        />
      ))}
    </Box>
  )
}
